import React, { useState, useEffect, useCallback, useMemo } from 'react';
import FlexView from 'react-flexview/lib';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup, EuiFlexItem, EuiSpacer} from '@elastic/eui';
import { ActionType, UPDATE, CREATE, DELETE, UPLOAD_CA, UPLOAD_CP } from './constants';
import { Action } from '../../components/Menus/interface';
import { Menu } from '../../components/Menus';
import ModalApp from '../../components/Modal';
import { FiltroCostos } from './Filtros';
import FormularioContainer from './UploadFile/container';
import ModalYesNo from '../../components/Modal/YesNo';
import { SelectorDescargaCertificadosDesplazados } from './CertificadosDesplazados';

interface Props {
  data: any;
  handleFilter(año: number): any;
  handleCreate(data: any): any;
  handleUpdate(data: any): any;
  handleRemove(data: any[]): any;
}

const CostosScreen = (props: Props) => {
  let { data, handleFilter, handleCreate, handleUpdate, handleRemove } = props;

  let [isModalVisible, setIsModalVisible] = useState(false);
  let [openRemoveModal, setOpenRemoveModal] = useState(false);
  let [selected, setSelected] = useState<any>([]);
  let [actionType, setActionType] = useState<ActionType>(CREATE);
  let [refresh, setRefresh] = useState(false);

  useEffect(()=>{
    closeModal(); 
    if(openRemoveModal){setOpenRemoveModal(false)}
   },[data])


  const closeModal = () => setIsModalVisible(false);
  const showModal = () => setIsModalVisible(true);

  const onRemove = useCallback(() => {
    if (selected && handleRemove) {
      if(selected.length > 1){
        setOpenRemoveModal(true)
      }else{
        const res = handleRemove(selected)
        if(res){
          setRefresh(true)
        }
      }
    }
  },[selected, handleRemove])

  const prepareCreate = useCallback(() => {
    setActionType(CREATE);
    showModal();
  },[])

  const prepareEdit = useCallback(() => {
    setActionType(UPDATE);
    showModal();
  },[])

  const prepareUploadCA = useCallback(() => {
    setActionType(UPLOAD_CA);
    showModal();
  },[])

  const prepareUploadCP = useCallback(() => {
    setActionType(UPLOAD_CP);
    showModal();
  },[])

  const onCreate = useCallback((newData: any) => {
    if (newData && handleCreate) {
      handleCreate(newData)
      setRefresh(true)
    }
  },[handleCreate])

  const onUpdate = useCallback((newData: any) => {
    if (handleUpdate && newData) {
      handleUpdate(newData)
      setRefresh(false)
    }
  },[handleUpdate])

  const onUpload = useCallback(() => {
   setRefresh(true)
   closeModal();
  },[])

  const onSelected = (selection: any) => {
    setSelected([...selection])
  }

  const getSelected = useMemo(() =>{
    return actionType.tipo === "U" ? selected[0] : undefined;
  },[actionType,selected])

  const onConfirmRemove = (response:any) => {
    if(response!==undefined && response === true){
      const res = handleRemove(selected)
      if(res){
        setRefresh(true)
      }
    }else{
      setOpenRemoveModal(false)
    }
  }

  const getHandle = useCallback(() =>{
    switch (actionType.tipo) {
      case 'I':return onCreate;
      case 'U':return onUpdate;
      case 'UFCA':return onUpload;
      case 'UFCP':return onUpload;
      default : return onCreate;
    }
  },[actionType,onCreate,onUpdate,onUpload])

  const Actions: Action[] = useMemo(()=> [
    {handle:prepareUploadCA,text:"Importar Coste Anual",color:"primary",size:"s",isDisabled:true},
    {handle:prepareUploadCP,text:"Importar CP/Indirectos",color:"primary",size:"s",isDisabled:true},
    {handle:onRemove,text:"Eliminar Selección",color:"danger",size:"s",isDisabled:(selected.length===0)},
    {handle:prepareEdit,text:"Editar Selección",color:"secondary",size:"s",isDisabled:(selected.length!==1)},
    {handle:prepareCreate,text:"Nuevo Costo",color:"primary",size:"s",isDisabled:true}
  ],[selected,prepareUploadCA,prepareUploadCP,onRemove,prepareEdit,prepareCreate])

  const contentModal = useCallback(() =>  <FormularioContainer tipo={actionType.tipo} handle={getHandle()} selected={getSelected} onClose={closeModal}/>,[actionType,getHandle,getSelected])
  const modal = useMemo(() => <ModalApp isOpen={isModalVisible} title={actionType.title} onClose={closeModal} content={contentModal()}/> ,[isModalVisible,actionType,contentModal])

  const getView = useMemo(() => {
    return (
      <>
        <GridResultsScreen
          data={data}
          selector={false}
          onSelected={onSelected}
          onChange={onUpdate}
        />
        {modal}
        {openRemoveModal ? <ModalYesNo onClose={onConfirmRemove} isOpen={openRemoveModal}/> : null}
      </>
    )
  },[data,modal,onUpdate,openRemoveModal,onConfirmRemove])

  const getFilters = useMemo(()=>{
    return <FiltroCostos onFilter={handleFilter} refresh = {refresh} setRefresh={setRefresh}/>
  },[refresh, handleFilter])

  return (
    <FlexView column basis="100%">
      <EuiFlexGroup gutterSize="s" alignItems="center" className="wrapperMenuPage">
        <EuiFlexGroup alignItems={'center'} justifyContent="flexStart" className="filter">
          {getFilters}
        </EuiFlexGroup>
        <EuiFlexGroup>
          <EuiFlexItem style={{alignItems:'flex-end'}}>
            <SelectorDescargaCertificadosDesplazados/>
          </EuiFlexItem>
          <EuiFlexItem>
          <Menu actions={Actions} className="actions"/>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexGroup>
       <EuiSpacer size="m" />
      <FlexView grow={1} shrink={1} basis="auto">
        <FlexView column shrink={0} basis="100%">
          {getView}
        </FlexView>
      </FlexView>
    </FlexView>
  );
};

export default CostosScreen;
